import _ from "lodash";
import angular from 'angular';

const merchantDeviceFactory =  function merchantDeviceFactory($rootScope, StorageService, StoreService, endPoints, $q, $log, NewBackendService) {
    "ngInject";
    const generatePaymentCodeStub = function() {
      return {
        "data": {
          "dtoReq": {

          }
        }
      };
    };

    return {
      generatePaymentCode: function(isBackground) {
        return $q(function(resolve, reject) {
          const stub = generatePaymentCodeStub();
          $log.debug(stub);

          NewBackendService.invokeWebApiPost("wallet_merchant/generatePaymentCode", stub, isBackground).then(function(promise) {
            const response = promise.data.dtoRes.dtoGeneratePaymentCodeRes;
            resolve(response);
          }, function(reason) {
            reject(reason);
          });
        });
      },
      generateNewAppMerchant: function(merchantDeviceName, standAlone, businessId, isBackground) {
        var request = {
          "merchantDeviceName": merchantDeviceName,
          "standAlone": standAlone,
          "businessId": businessId,
          "shopId": StoreService.getSelectedStore().id
        }
        return $q(function(resolve, reject) {
          NewBackendService.invokeWebApiPost(`${endPoints.deviceUrl}/devices`, request, isBackground).then(function(promise) {
            //const response = promise.data.dtoRes.dtoActivateMerchantDeviceRes;
            resolve();
          }, function(reason) {
            reject(reason);
          });
        });
      },
      getMerchantDeviceDetail: function(isBackground) {
        return $q(function(resolve, reject) {
          const request = {
            "data": {
              "dtoReq": {}
            }
          };
          NewBackendService.invokeWebApiPost("wallet_merchant/getMerchantDeviceDetail", request, isBackground).then(function(promise) {
            const response = promise.data.dtoRes.dtoMerchantDeviceInfo;
            resolve(response);
          }, function(error) {
            reject(error);
          });
        });
      },
      getPaymentCode: function(type, paymentCodeType, isBackground) {
        const request = {
          "data": {
            "dtoReq": {
              "dtoGetPaymentCodeReq": {
                'type': type,
                'paymentCodeType': paymentCodeType
              }
            }
          }
        };
        return $q(function(resolve, reject) {
          NewBackendService.invokeWebApiPost("wallet_merchant/getPaymentCode", request, isBackground).then(function(promise) {
            const response = promise.data.dtoRes.dtoGetPaymentCodeRes;
            resolve(response);
          }, function(reason) {
            reject(reason);
          });
        });
      }
    };
  };

export default merchantDeviceFactory;



/** WEBPACK FOOTER **
 ** ./client/app/common/services/tinaba-framework/merchantDevice.factory.js
 **/